import script from "./PolymersRepository.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolymersRepository.vue?vue&type=script&setup=true&lang=ts"

import "./PolymersRepository.vue?vue&type=style&index=0&id=d780affc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d780affc"]])

export default __exports__